import App from '@/models/App'

export default class ShipSailorInfoBasePeriodHistory extends App {
    static get entity() {
        return 'ShipSailorInfoBasePeriodHistories'
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            shipSailorId: this.attr(''),
            basePeriod: this.attr(''),
            startingAt: this.attr(''),
            lastAt: this.attr(''),
            paidHolidays: this.attr(''),
            holidays: this.attr(''),
            isHolidays: this.attr(''),
            modifyName: this.attr(''),
            isDeleted: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static findByDate(date) {
        return this.query()
            .where('startingAt', (value) => value <= date)
            .where('lastAt', (value) => value >= date)
            .where('isDeleted', false)
            .first()
    }

    static getOtherHistories(shipSailorId, basePeriodHistoryId) {
        return this.query()
            .where((value) => {
                return (
                    value.shipSailorId === shipSailorId &&
                    value.id !== basePeriodHistoryId &&
                    value.isDeleted === false
                )
            })
            .withAllRecursive()
            .get()
    }

    static apiConfig = {
        actions: {
            fetch(shipId, shipSailorId) {
                return this.get(
                    `${shipId}/sailors/${shipSailorId}/infos/base/period/histories`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(
                shipId,
                shipSailorId,
                shipSailorInfoBasePeriodHistoryId,
                params
            ) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/base/period/histories/${shipSailorInfoBasePeriodHistoryId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, shipSailorId, shipSailorInfoBasePeriodHistoryId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(
                    `${shipId}/sailors/${shipSailorId}/infos/base/period/histories/${shipSailorInfoBasePeriodHistoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: shipSailorInfoBasePeriodHistoryId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
